import { creditAccountsUrl } from "./endpoints.js";
const creditAccountsCacheKey = () => [creditAccountsUrl];
export {
  creditAccountsCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
